module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/gifs/email-extension-6-end.gif"